import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPersonWalkingArrowRight,} from "@fortawesome/free-solid-svg-icons";

interface IIcon {
  color: string;
}

const TraceFollowIcon: React.FC<IIcon> = ({ color }) => {
  return <FontAwesomeIcon icon={faPersonWalkingArrowRight} style={{ color }} />;
};

export default TraceFollowIcon;